import { alphaNumeric, alphanumericMajuscule, integerOnly, numberUpToFourDigitsAndTwoDecimals, yearAsInteger } from './patterns';
import { ValidatorFn, Validators } from '@angular/forms';
import { odfPatterValidator } from '@app/shared/base-form/validators-config';

export const customOdfValidatorConfig = {
    descripteursObjetMaquette: {
        code: {
            required: true,
            min: 3,
            max: 25,
            patternMatch: {
                pattern: alphaNumeric,
                message: 'Le code doit contenir uniquement des caractères alphanumériques et/ou le tiret'
            }
        },
        typeObjetMaquette: {
            required: true
        },
        mutualise: {
            required: true
        },
        libelle: {
            required: true,
            min: 3,
            max: 50
        },
        libelleLong: {
            required: true,
            min: 3,
            max: 150
        },
        description: {
            max: 2000
        },
        ects: {
            patternMatch: {
                pattern: numberUpToFourDigitsAndTwoDecimals,
                message: 'Le format est incorrect: format attendu XXXX.XX'
            }
        },
        structurePrincipale: {},
        stage: {
            required: true
        },
        nature: {},
        teleEnseignement: {
            required: true
        },
        typeObjetFormation: {
            required: true
        },
        natureObjetFormation: {},
        capaciteAccueil: {
            patternMatch: {
                pattern: integerOnly,
                message: 'Nombre entier uniquement'
            },
            min: 0,
            max: 4
        },
        // FORMATION
        typeFormation: {
            required: true
        },
        // GROUPEMENT
        plageDeChoix: {},
        natureGroupement: {},
        plageDeChoixMin: {
            patternMatch: {
                pattern: integerOnly,
                message: 'Nombres entiers uniquement'
            }
        },
        plageDeChoixMax: {
            patternMatch: {
                pattern: integerOnly,
                message: 'Nombres entiers uniquement'
            }
        }
    },

    descripteursContexte: {
        ects: {
            patternMatch: {
                pattern: numberUpToFourDigitsAndTwoDecimals,
                'message': 'Le format est incorrect: format attendu XXXX.XX'
            }
        },
        natureObjetFormation: {},
        natureGroupement: {},
        plageDeChoixMin: {
            patternMatch: {
                pattern: integerOnly,
                message: 'Nombres entiers uniquement'
            }
        },
        plageDeChoixMax: {
            patternMatch: {
                pattern: integerOnly,
                message: 'Nombres entiers uniquement'
            }
        }
    },

    descripteursEspace: {
        code: {
            required: true,
            min: 3,
            max: 15,
            patternMatch: {
                pattern: alphanumericMajuscule,
                message: 'Le code doit contenir uniquement des caractères alphanumériques et/ou le tiret'
            }
        },
        libelle: {
            required: true,
            min: 4,
            max: 100
        },
        libelleLong: {
            required: true,
            min: 4,
            max: 255
        },
        libelleAffichage: {
            required: true,
            min: 4,
            max: 150
        },
        active: {
            required: true
        },
        anneeUniversitaire: {
            patternMatch: {
                pattern: yearAsInteger,
                message: "L'année universitaire doit être un nombre à 4 chiffres ex: 2020"
            },
            min: 4,
            max: 4
        },
        typeEspace: {
            required: true
        },
        type: {
            required: true
        },
        validite: {
            required: true
        },
        dateDebut: {
            required: true
        },
        dateFin: {
            required: true
        },
        dateConsommationNomenclatures: {
            required: true
        }
    },

    descripteursDiplomeCertificatAutre: {
        code: {
            required: true,
            min: 3,
            max: 15,
            patternMatch: {
                pattern: alphanumericMajuscule,
                message: 'Le code doit contenir uniquement des caractères alphanumériques et/ou le tiret'
            }
        },
        finaliteDiplome: {
            required: true
        },
        libelle: {
            required: true,
            min: 1,
            max: 50
        },
        intitule: {
            required: true,
            min: 1,
            max: 500
        },
        actif: {
            required: true
        },
        // diplomeDiplomantDescripteurs contient les suivants
        diplomeDiplomantDescripteurs: {},
        typeDiplome: {
            required: true
        },
        niveauDiplome: {},
        domaine: {},
        mention: {},
        champDiplome: {}
    }
};

export function generateDescripteursValidators(descripteurs: object) {
    const validatorsObject: { [key: string]: ValidatorFn[] } = {};
    for (const propertyName in descripteurs) {
        if (Object.prototype.hasOwnProperty.call(descripteurs, propertyName)) {
            const validators: ValidatorFn[] = [];
            if (descripteurs[propertyName].required) {
                validators.push(Validators.required);
            }
            if (descripteurs[propertyName].min !== undefined) {
                validators.push(Validators.minLength(descripteurs[propertyName].min));
            }
            if (descripteurs[propertyName].max !== undefined) {
                validators.push(Validators.maxLength(descripteurs[propertyName].max));
            }
            if (descripteurs[propertyName].patternMatch) {
                validators.push(odfPatterValidator(descripteurs[propertyName].patternMatch));
            }
            validatorsObject[propertyName] = validators;
        }
    }
    return validatorsObject;
}

export const customOdfValidators = {
    descripteursObjetMaquette: generateDescripteursValidators(customOdfValidatorConfig.descripteursObjetMaquette),
    descripteursContexte: generateDescripteursValidators(customOdfValidatorConfig.descripteursContexte),
    descripteursEspace: generateDescripteursValidators(customOdfValidatorConfig.descripteursEspace),
    descripteursDiplomeCertificatAutre: generateDescripteursValidators(customOdfValidatorConfig.descripteursDiplomeCertificatAutre)
};
